import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import PagesLayout from 'layout/Pages';
import SimpleLayout from 'layout/Simple';

import { SimpleLayoutType } from 'config';
import { getSubRoot } from '../utils/utils.jsx';
import ContentAggregation from "@/pages/extra-pages/ContentAggregation";
import DashboardPage from "@/pages/extra-pages/dashboard-page";
import {CONTENT_AGGREGATION_PAGE_NAME, EDITOR_PAGE_NAME, LIBRARY_PAGE_NAME, EVENTS_PAGE_NAME} from "@/constants/globalConstants";
import RulesPage from "@/pages/extra-pages/rules-page";
import RuleForgePage from "@/pages/extra-pages/ruleForgePage";
import SocialAccountPage from "@/pages/extra-pages/SocialAccountPage";
import SocialPublishPage from "@/pages/extra-pages/SocialPublishPage";
import UserPage from "@/pages/extra-pages/UserPage";
import RoleForgePage from "@/pages/extra-pages/roleForgePage";
import {Privacy} from "../pages/extra-pages/PrivacyTermsOfService/Privacy";
import {TermOfService} from "../pages/extra-pages/PrivacyTermsOfService/TermOfService";
import {DataDeletion} from "../pages/extra-pages/PrivacyTermsOfService/DataDeletion";

// pages routing
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

const AppContactUS = Loadable(lazy(() => import('pages/contact-us')));

const IngestionPage = Loadable(lazy(() => import('pages/extra-pages/ingestion-page')));
const KeyMomentsPage = Loadable(lazy(() => import('pages/extra-pages/keymoments-page')));
const VideoClipManager = Loadable(lazy(() => import('pages/extra-pages/video-clip-manager-page')));
const ClipsPage = Loadable(lazy(() => import('pages/extra-pages/clips-page')));
const NewEventPage = Loadable(lazy(() => import('pages/extra-pages/new-page')));
const ProcessingPage = Loadable(lazy(() => import('pages/extra-pages/processing-page')));
const ClipRenderingPage = Loadable(lazy(() => import('pages/extra-pages/clipRendering-page')));
const EditorPage = Loadable(lazy(() => import('pages/extra-pages/editor-page.tsx')));
const KeyMomentsCollectionPage = Loadable(lazy(() => import('pages/extra-pages/keyMomentsCollection-page')));
const ClipsCollectionPage = Loadable(lazy(() => import('pages/extra-pages/clipsCollection-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: getSubRoot(window.location.pathname),
    children: [
      {
        path: '',
        element: <DashboardLayout />,
        children: [
          {
            path: EVENTS_PAGE_NAME,
            element: <IngestionPage />
          },
          {
            path: `${EVENTS_PAGE_NAME}/newevent`,
            element: <NewEventPage />
          },
          {
            path: `${EVENTS_PAGE_NAME}/processing`,
            element: <ProcessingPage />
          },
          {
            path: 'keymoments',
            element: <KeyMomentsPage />,
          },
          {
            path: 'keymoments/' + EDITOR_PAGE_NAME,
            element: <EditorPage />,
          },
          {
            path: 'clips/' + EDITOR_PAGE_NAME,
            element: <EditorPage />,
          },
          {
            path: 'keymoments/'+ LIBRARY_PAGE_NAME,
            element: <VideoClipManager />
          },
          {
            path: 'keymoments/newcollection',
            element: <KeyMomentsCollectionPage />
          },
          {
            path: 'keymoments/editcollection',
            element: <KeyMomentsCollectionPage />
          },
          {
            path: 'clips',
            element: <ClipsPage />,
          },
          {
            path: 'clips/'+ LIBRARY_PAGE_NAME,
            element: <VideoClipManager />
          },
          {
            path: 'clips/newcollection',
            element: <ClipsCollectionPage />
          },
          {
            path: 'clips/editcollection',
            element: <ClipsCollectionPage />
          },
          {
            path: 'renderingjob',
            element: <ClipRenderingPage />
          },
          {
            path: 'dashboard',
            element: <DashboardPage />
          },
          {
            path: 'rules',
            element: <RulesPage />,
          },
          {
            path: 'automation_forge',
            element: <RuleForgePage/>
          },
          {
            path: 'social',
            element: <SocialAccountPage/>
          },
          {
            path: 'publish',
            element: <SocialPublishPage/>
          },
          {
            path: 'users',
            element: <UserPage/>
          },
          {
            path: 'role',
            element: <RoleForgePage/>
          },
          {
            path: 'privacy_policy',
            element: <Privacy/>
          },
          {
            path: 'term_of_service',
            element: <TermOfService/>
          },
          {
            path: 'data_deletion',
            element: <DataDeletion/>
          },
          {
            path: CONTENT_AGGREGATION_PAGE_NAME,
            children: [
              /*{
                path: "match_highlight",
                element: <ContentAggregation/>,
              },
              {
                path: "clip",
                element: <ContentAggregation/>,
              }*/
              {
                path: "*",
                element: <ContentAggregation/>,
              }
            ]
          }
        ]
      },
      {
        path: 'maintenance',
        element: <PagesLayout />,
        children: [
          {
            path: '404',
            element: <MaintenanceError />
          },
          {
            path: '500',
            element: <MaintenanceError500 />
          },
          {
            path: 'under-construction',
            element: <MaintenanceUnderConstruction />
          },
          {
            path: 'coming-soon',
            element: <MaintenanceComingSoon />
          }
        ]
      },
      {
        path: '',
        element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
        children: [
          {
            path: 'contact-us',
            element: <AppContactUS />
          }
        ]
      }
    ]
  };

export default MainRoutes;
